/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export type TConstantType = string | number | boolean | null;

export enum CONSTANTS_TYPES {
	string = "string",
	number = "number",
	boolean = "boolean"
}

export interface IConstantEnvVar {
	name: string;
	type: CONSTANTS_TYPES;
	default: TConstantType;
	public: boolean;
}

export interface IConstant {
	value: TConstantType;
	public: boolean;
}

export interface IConstantsManifest {
	[K: string]: {
		type: "constant" | "envvar";
		value: {
			constant: IConstant;
			envvar: IConstantEnvVar;
		};
	};
}

export interface IConstants {
	[K: string]: TConstantType;
}
